
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"11","viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.203 4.472c.057-.049.27-.255.469-.425 1.165-1.07 4.204-2.82 5.795-3.354C7.71.607 8.32.426 8.646.414c.313 0 .61.06.895.182.355.17.64.437.795.753.1.22.256.875.256.887.156.717.242 1.883.242 3.171 0 1.228-.086 2.346-.213 3.075-.015.011-.17.826-.341 1.105-.313.51-.924.827-1.578.827h-.056c-.426-.012-1.321-.33-1.321-.34-1.505-.536-4.474-2.2-5.668-3.306 0 0-.336-.284-.482-.461a1.326 1.326 0 01-.341-.887c0-.353.128-.68.37-.948z"}})])
          )
        }
      }
    